
<div class="title">
    <span>BECOME A <img class="image-logo" src="../../assets/tyt_logo_outline_white.png" alt="tyt-logo"> MEMBER</span>
    <a href="{{joinUrl}}"><tyt-form-submit-button>Join Now</tyt-form-submit-button></a>
    <a routerLink="/membership-benefits">Learn More</a>
</div>
